/*
  HULK customization - February 2025 (Demir Pasalic)
  --------------------------------------------------
  Image gallery consisting of three sliding images that change based on the selected product options
  Also consisting of three additional images for resin samples below the sliding images
*/

window.addEventListener("load", () => {
	var splide = new Splide(".splide");
	splide.mount();

	const state = {
		TopCaseColour: "",
		BottomCaseColour: "",
		Layout: "",
		AccentMaterial: "",
		NavigationBadge: "",
		F13Badge: "",
		BackplateCutout: "",
		Plate: "",
		PCB: ""
	};
	let weightState = 2.1;
	let expandModalOpenTimeout;

	const modalOpenButton = document.querySelector(".modal-open");
	const imageBoxContainer = document.querySelector(".image-box-container");
	modalOpenButton.addEventListener("click", () => {
		imageBoxContainer.classList.add("active");
		modalOpenButton.classList.remove("expand");
	})

	const modalCloseButton = document.querySelector(".image-box-container-close > button");
	modalCloseButton.addEventListener("click", () => {
		imageBoxContainer.style.transition = "none";
		imageBoxContainer.classList.remove("active");
		setTimeout(() => {
			imageBoxContainer.style.transition = "visibility 300ms, opacity 300ms, padding 250ms";
		}, 350);
	});

	const weightElement = document.querySelector(".splide .weight");

	const galleryLoaderList = document.querySelectorAll(".image-container .splide .splide__slide .loader");
	const imageBoxesLoaderList = document.querySelectorAll(".image-container .image-box .loader");

	const galleryImagesList = document.querySelectorAll(".image-container .splide .splide__list .splide__slide img");
	const imageBoxesList = document.querySelectorAll(".image-container .image-box img");

	let optionSet;
	const interval = setInterval(() => {
		optionSet = document.querySelector(".hulkapps_option_set");
		if (optionSet) {
			clearInterval(interval);
			initializeGallery();

			const selectedNavigationBadge = optionSet.querySelector(".hulkapps_option div[aria-label='Navigation Badge'] + div > input").value;
			const selectedF13Badge = optionSet.querySelector(".hulkapps_option div[aria-label='F13 Badge'] + div > input").value;
			const imageBoxTwo = document.querySelector(".image-container .image-box.image-two");
			const imageBoxThree = document.querySelector(".image-container .image-box.image-three");
			if (!selectedNavigationBadge.includes("Resin") && !selectedNavigationBadge.includes("Split")) {
				imageBoxTwo.classList.add("image-box-hidden");
			}
			if (!selectedF13Badge.includes("Resin") && !selectedNavigationBadge.includes("Split")) {
				imageBoxThree.classList.add("image-box-hidden");
			}

			const selectedAccentMaterial = optionSet.querySelector(".hulkapps_option div[aria-label='Accent Material'] + div > input").value;
			const walnutLabel = optionSet.querySelector(".hulkapps_option div[aria-label='Navigation Badge'] + div label[aria-label^='Walnut']");
			const oakLabel = optionSet.querySelector(".hulkapps_option div[aria-label='Navigation Badge'] + div label[aria-label^='Oak']");
			if (selectedAccentMaterial.includes("Walnut")) {
				walnutLabel.style.display = "unset";
				oakLabel.style.display = "none";
			} else if (selectedAccentMaterial.includes("Oak")) {
				walnutLabel.style.display = "none";
				oakLabel.style.display = "unset";
			} else {
				walnutLabel.style.display = "unset";
				oakLabel.style.display = "unset";
			}

			const optionList = optionSet.querySelectorAll(".hulkapps_option_set .hulkapps_option");
			optionList.forEach(option => {
				const required = option.querySelector(".hulkapps_option_name > .hulkapps-required");
				if (required) {
					required.textContent = "required";
				}

				const labelsList = option.querySelectorAll(".hulkapps_option_value > label");
				labelsList.forEach(label => {
					const labelAriaVal = label.getAttribute("aria-label");
					const hasCharge = /\(\+\$\d+(\.\d{2})?\)/.test(labelAriaVal);
					const radioSpanElement = label.querySelector(".hulkapps-tooltip > div:nth-child(2) > div > span");
					if (hasCharge) {
						radioSpanElement.innerHTML += `<span>${" $" + labelAriaVal.match(/\(\+\$(\d+(\.\d{2})?)\)/)[1]}</span>`;
					}
				});
			});

			const optionKeys = Object.keys(state);

			optionKeys.forEach((key) => {
				const formattedLabel = key.replace(/([A-Z])/g, " $1").trim();
				const radioButtons = optionSet.querySelectorAll(
					`div[aria-label='${formattedLabel}'] + .hulkapps_option_value > label > .hulkapps-tooltip input.button_radio`
				);

				radioButtons.forEach((radio) => {
					const matchOptionWeight = radio.parentElement.dataset.shippingWeight.match(/\d+(\.\d+)?/);
					if (radio.parentElement.classList.contains("button_selected") && matchOptionWeight) {
						const optionWeight = Number(matchOptionWeight[0]);
						weightState += optionWeight;
					}
					radio.addEventListener("click", (event) => {
						const val = event.target.value.match(/^([\w\s]+)\s*(?:\[|$)/)[1].trim();
						state[key] = val;
						updateGalleryImagesLink();
						updateImageBoxesLink();
						if (key === "NavigationBadge") {
							setTimeout(() => {
								imageBoxTwo.scrollIntoView({ behavior: "smooth", block: "center" });
							}, 50);
							if (val === "Resin" || val === "Split") {
								imageBoxTwo.classList.remove("image-box-hidden");
								modalOpenButton.classList.add("expand");
								clearTimeout(expandModalOpenTimeout);
								expandModalOpenTimeout = setTimeout(() => {
									modalOpenButton.children[1].style.color = "#0000";
									setTimeout(() => {
										modalOpenButton.children[1].style.color = "#000";
									}, 400);
									modalOpenButton.classList.remove("expand");
								}, 5000);
							} else {
								imageBoxTwo.classList.add("image-box-hidden");
							}
						} else if (key === "F13Badge") {
							setTimeout(() => {
								imageBoxThree.scrollIntoView({ behavior: "smooth", block: "center" });
							}, 50);
							if (val === "Resin" || val === "Split" || val === "Resin_Keycap") {
								imageBoxThree.classList.remove("image-box-hidden");
								modalOpenButton.classList.add("expand");
								clearTimeout(expandModalOpenTimeout);
								expandModalOpenTimeout = setTimeout(() => {
									modalOpenButton.children[1].style.color = "#0000";
									setTimeout(() => {
										modalOpenButton.children[1].style.color = "#000";
									}, 400);
									modalOpenButton.classList.remove("expand");
								}, 5000);
							} else {
								imageBoxThree.classList.add("image-box-hidden");
							}
						} else if (key === "AccentMaterial") {
							const navigationBadgeLabelElement = optionSet.querySelector(".hulkapps_option div[aria-label='Navigation Badge']");
							const walnutLabel = navigationBadgeLabelElement.nextSibling.querySelector("label[aria-label^='Walnut']");
							const oakLabel = navigationBadgeLabelElement.nextSibling.querySelector("label[aria-label^='Oak']");
							const noneLabel = navigationBadgeLabelElement.nextSibling.querySelector("label[aria-label^='None']");
							const navigationBadgeVal = navigationBadgeLabelElement.nextSibling.querySelector("input[type='hidden']").value;
							if (val === "Walnut") {
								walnutLabel.style.display = "unset";
								oakLabel.style.display = "none";
							} else if (val === "Oak") {
								walnutLabel.style.display = "none";
								oakLabel.style.display = "unset";
							} else {
								walnutLabel.style.display = "none";
								oakLabel.style.display = "none";
							}

							if (
								(val === "Walnut" && navigationBadgeVal.includes("Oak")) ||
								(val === "Oak" && navigationBadgeVal.includes("Walnut")) ||
								(val === "Brass" && (navigationBadgeVal.includes("Walnut") || navigationBadgeVal.includes("Oak")))
							) {
								noneLabel.click();
							}
						}
// --- Robust weight recalculation ---
setTimeout(() => {
  // Start from base weight
  weightState = 2.1;

  // Find all selected options across the configurator
  const selectedButtons = document.querySelectorAll(".hulkapps_option_value > label > .hulkapps-tooltip div.button_selected");

  selectedButtons.forEach(selectedButton => {
    let w;

    // Try the most likely locations for the weight data
    if (selectedButton.dataset?.shippingWeight) {
      w = selectedButton.dataset.shippingWeight;
    } else if (selectedButton.closest('label')?.dataset?.shippingWeight) {
      w = selectedButton.closest('label').dataset.shippingWeight;
    } else if (selectedButton.parentElement?.dataset?.shippingWeight) {
      w = selectedButton.parentElement.dataset.shippingWeight;
    }

    // Extract the numeric value and add it
    if (w) {
      const match = w.match(/-?\d+(\.\d+)?/);
      if (match) weightState += parseFloat(match[0]);
    }
  });

  // Update displayed total once
  if (weightElement) {
    weightElement.textContent = "≈ " + weightState.toFixed(2) + " kg";
  }
}, 30); // slight delay so Hulk updates DOM first
// --- end weight recalculation ---

					});
					weightElement.textContent = "≈ " + weightState.toFixed(2) + " kg";
				});
			});
		}
	}, 100);

	function updateGalleryImagesLink() {
		const baseURL = "https://cdn.shopify.com/s/files/1/0785/1026/0531/files/";
		const queryParams = "?v=1739182323";

		const selectedState = {
			image1: [state.TopCaseColour, state.Layout, state.AccentMaterial, state.NavigationBadge, state.F13Badge],
			image2: [state.TopCaseColour, state.BottomCaseColour, state.AccentMaterial, state.BackplateCutout],
			image3: [state.TopCaseColour, state.BottomCaseColour]
		};

		galleryImagesList.forEach((imageElement, index) => {
			imageElement.addEventListener("load", () => {
				imageElement.nextElementSibling.classList.remove("loader-active");
			});
			const selectedValues = Object.values(selectedState[`image${index + 1}`]).filter(value => value);
			const len = selectedValues.length;

			if (len > 0 && ((len === 5 && index === 0) || (len === 4 && index === 1) || (len === 2 && index === 2))) {
				const imageUrl = `${baseURL}${selectedValues.join("_-_")}.png${queryParams}`;
				validateAndSetImage(galleryImagesList[index], imageUrl, index);
			}
		});
	}

	function updateImageBoxesLink() {
		const baseURL = "https://cdn.shopify.com/s/files/1/0785/1026/0531/files/";
		const queryParams = "?v=1739182323";

		const selectedState = {
			image1: ["Backplate_Resin", state.BottomCaseColour],
			image2: ["Navigation_Badge_Resin", state.TopCaseColour],
			image3: ["F13_Badge_Resin", state.TopCaseColour]
		};

		imageBoxesList.forEach((imageElement, index) => {
			imageElement.addEventListener("load", () => {
				imageElement.nextElementSibling.classList.remove("loader-active");
			});
			const selectedValues = Object.values(selectedState[`image${index + 1}`]).filter(value => value);

			const imageUrl = `${baseURL}${selectedValues.join("_")}.png${queryParams}`;
			validateAndSetImage(imageBoxesList[index], imageUrl, index);
		});
	}

	function initializeGallery() {
		const optionKeys = Object.keys(state);

		optionKeys.forEach((key) => {
			const formattedLabel = key.replace(/([A-Z])/g, " $1").trim();
			const selectedRadioButton = optionSet.querySelector(
				`div[aria-label='${formattedLabel}'] + .hulkapps_option_value > label > .hulkapps-tooltip div.button_selected`
			);
			state[key] = selectedRadioButton?.getAttribute("value");
		});

		updateGalleryImagesLink();
		updateImageBoxesLink();
	}

	function validateAndSetImage(imgElement, imgUrl, imgIndex) {
		galleryLoaderList[imgIndex].classList.add("loader-active");
		imageBoxesLoaderList[imgIndex].classList.add("loader-active");

		const testImage = new Image();

		testImage.onload = function () {
			imgElement.src = imgUrl;
			adjustContentSpacing();
		};

		// testImage.onerror = function () {
		// 	galleryLoaderList[imgIndex].classList.remove("loader-active");
		// 	imageBoxesLoaderList[imgIndex].classList.remove("loader-active");
		// };

		testImage.src = imgUrl;
	}
});

function adjustContentSpacing() {
	const fixedImage = document.querySelector(".splide");
	const content = document.querySelector(".product");

	if (fixedImage && content) {
		const imageHeight = fixedImage.clientHeight;
		content.style.marginTop = `${imageHeight - 110}px`;
	}
}
window.addEventListener("resize", adjustContentSpacing);
